function SortAccordion (sortOptions = []) {
  if (!sortOptions || sortOptions.length === 0) {
    return ''
  }

  return `
    <li class="clc-ProductGridFacets_Item">
      <details class="clc-ProductGridFacet" data-sort-accordion>
        <summary class="clc-ProductGridFacet_Summary">
          <span class="clc-ProductGridFacet_FilterLabel fz-16_18">
            Sort by
          </span>
        </summary>
        <div class="clc-ProductGridFacet_Display">
          <div class="clc-ProductGridFacet_Body">
            <div class="clc-ProductGridFacet_List">
              ${sortOptions
                .map(option => {
                  return `
                    <div class="clc-ProductGridFacet_Item">
                      <button
                        type="button"
                        class="clc-Sort_Facet"
                        data-sort-value="${option.field}~${option.order}"
                        aria-pressed="${option.selected ? 'true' : 'false'}"
                      >
                        ${option.label}
                      </button>
                    </div>
                  `
                })
                .join('')}
            </div>
          </div>
        </div>
      </details>
    </li>
  `
}

window.theme.results.templates.SortAccordion = SortAccordion
